import React from 'react';
import { Check, X, ShieldCheck } from 'lucide-react';

const MarketerSocialProof: React.FC = () => {
  return (
    <>
      {/* COMPARISON */}
      <section className="py-24 bg-slate-900 border-t border-slate-800">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-white">Why Marketers Switch to ProGeoData</h2>
          </div>

          <div className="overflow-x-auto">
            <table className="w-full border-collapse">
              <thead>
                <tr>
                  <th className="p-4 text-left text-slate-500 font-medium"></th>
                  <th className="p-4 text-center bg-sky-900/10 border-t-4 border-sky-500 rounded-t-lg">
                    <span className="text-lg font-bold text-white">ProGeoData</span>
                  </th>
                  <th className="p-4 text-center text-slate-400 font-medium">ZoomInfo/Apollo</th>
                  <th className="p-4 text-center text-slate-400 font-medium">Manual Research</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-800">
                <tr>
                  <td className="p-4 text-slate-300 font-medium">Cost</td>
                  <td className="p-4 text-center bg-sky-900/5 font-bold text-white">$99-499/mo</td>
                  <td className="p-4 text-center text-slate-400">$15,000+/yr</td>
                  <td className="p-4 text-center text-slate-400">$500+/week labor</td>
                </tr>
                <tr>
                  <td className="p-4 text-slate-300 font-medium">Data Focus</td>
                  <td className="p-4 text-center bg-sky-900/5 text-sky-300 font-medium">Licensed Pros Only</td>
                  <td className="p-4 text-center text-slate-400">Generic B2B</td>
                  <td className="p-4 text-center text-slate-400">Whatever you find</td>
                </tr>
                <tr>
                  <td className="p-4 text-slate-300 font-medium">License Verification</td>
                  <td className="p-4 text-center bg-sky-900/5">
                    <div className="inline-flex items-center text-emerald-400 font-medium"><Check className="w-4 h-4 mr-1"/> Real-time, daily</div>
                  </td>
                  <td className="p-4 text-center text-slate-500">
                     <div className="inline-flex items-center"><X className="w-4 h-4 mr-1"/> Not available</div>
                  </td>
                  <td className="p-4 text-center text-slate-500">Manual lookup</td>
                </tr>
                <tr>
                  <td className="p-4 text-slate-300 font-medium">Data Freshness</td>
                  <td className="p-4 text-center bg-sky-900/5 text-white">Daily Updates</td>
                  <td className="p-4 text-center text-slate-400">Quarterly Refresh</td>
                  <td className="p-4 text-center text-slate-400">Stale Immediately</td>
                </tr>
                <tr>
                  <td className="p-4 text-slate-300 font-medium">Minimum Commitment</td>
                  <td className="p-4 text-center bg-sky-900/5 text-white">None (Monthly)</td>
                  <td className="p-4 text-center text-slate-400">Annual Contract</td>
                  <td className="p-4 text-center text-slate-400">Your Time</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>

      {/* TRUST SIGNALS */}
      <section className="py-16 bg-slate-950 border-t border-slate-900">
        <div className="max-w-7xl mx-auto px-4 text-center">
          <h3 className="text-sm font-bold text-slate-500 uppercase tracking-widest mb-8">Built for Compliance-Conscious Marketers</h3>
          
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            <div className="flex flex-col items-center">
               <ShieldCheck className="w-8 h-8 text-slate-700 mb-3" />
               <span className="text-slate-400 text-sm font-medium">Official State Data</span>
            </div>
            <div className="flex flex-col items-center">
               <ShieldCheck className="w-8 h-8 text-slate-700 mb-3" />
                <span className="text-slate-400 text-sm font-medium">Regular Verification</span>
            </div>
            <div className="flex flex-col items-center">
               <ShieldCheck className="w-8 h-8 text-slate-700 mb-3" />
               <span className="text-slate-400 text-sm font-medium">No Data Reselling</span>
            </div>
            <div className="flex flex-col items-center">
               <ShieldCheck className="w-8 h-8 text-slate-700 mb-3" />
               <span className="text-slate-400 text-sm font-medium">SOC 2 Compliant</span>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default MarketerSocialProof;